import React from 'react'

export default function EmployeesPaymentAppearance() {
  return (
    <div>EmployeesPaymentAppearance</div>
  )
}
